// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

// Types
import type { ChartType } from '@/lib/analytics/charts/chart.type';

export const sharesHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.youtube.share_history',
    tooltip: 'chart.youtube.tooltip_shares_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.youtube.share_history_name',
        avg: 'chart.youtube.avg_share_history'
    },
    id: 'shares_history',
    color: {
        value: 'purple',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.youtube.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
